import { useLanguage } from "@/contexts/LanguageContext";
import { Mail, Phone } from "lucide-react";

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();
  
  const scrollToSection = (href: string) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-card border-t border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
          {/* Company Info */}
          <div className="space-y-4">
            <img 
              src="/lovable-uploads/50355940-4071-4f39-8046-9727ab73dae8.png" 
              alt="MindSite AI"
              width="160"
              height="80" 
              className="h-20 w-auto mix-blend-multiply dark:mix-blend-screen"
            />
            <p className="text-muted-foreground text-sm">
              {t('footer.description')}
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="font-semibold text-foreground">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection("#showcase")}
                  className="text-muted-foreground hover:text-primary transition-colors text-sm"
                >
                  {t('nav.showcase')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("#pricing")}
                  className="text-muted-foreground hover:text-primary transition-colors text-sm"
                >
                  {t('nav.pricing')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("#how-it-works")}
                  className="text-muted-foreground hover:text-primary transition-colors text-sm"
                >
                  {t('nav.howItWorks')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("#faq")}
                  className="text-muted-foreground hover:text-primary transition-colors text-sm"
                >
                  {t('nav.faq')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("#contact")}
                  className="text-muted-foreground hover:text-primary transition-colors text-sm"
                >
                  {t('nav.contact')}
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="font-semibold text-foreground">{t('footer.contact')}</h3>
            <a 
              href="mailto:ahoj@waitwhat.sk"
              className="flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors text-sm"
            >
              <Mail className="h-4 w-4" />
              ahoj@waitwhat.sk
            </a>
            <a 
              href="tel:+421949021133"
              className="flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors text-sm"
            >
              <Phone className="h-4 w-4" />
              +421 949 021 133
            </a>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-border mt-8 pt-8 text-center">
          <p className="text-muted-foreground text-sm">
            © {currentYear} MindSite AI by{" "}
            <a 
              href="https://www.waitwhat.sk" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-accent hover:text-accent/80 transition-colors underline"
            >
              Wait What
            </a>
            . All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;